// removed by extract-text-webpack-plugin
module.exports = {"inputPhone":"_2gB5n","countryDropdownButton":"_2PYaw","countryDropdown":"_3PIxW"};


//////////////////
// WEBPACK FOOTER
// ./src/views/components/PhoneInput/PhoneInput.less
// module id = 833
// module chunks = 0